import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { HrtBookmarkComponent } from 'src/app/shared/components/hrt-bookmark/hrt-bookmark.component';
import { ApiService } from 'src/app/shared/services/api.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { Router } from '@angular/router';
import { SnackbarV3Service } from '@gea/digital-ui-lib';
import { Document } from 'src/app/shared/data/data.generated';

@Component({
  selector: 'gea-document-details',
  templateUrl: './document-details.component.html',
  styleUrl: './document-details.component.scss',
  standalone: false,
})
export class DocumentDetailsComponent {
  @Input() selectedDoc: any;
  @Output() exitDetails = new EventEmitter();

  id: number;
  downloading = false;
  public url: any;
  public bookmarkName: any;
  public bookmarkType: string = 'Document';
  public isBookmark: boolean;
  public link: any;

  constructor(
    private api: ApiService,
    private route: ActivatedRoute,
    private loader: LoaderService,
    public dialog: MatDialog,
    private router: Router,
    private snackbar: SnackbarV3Service,
  ) {}

  ngOnInit() {
    this.route.params.subscribe((p: any) => {
      this.id = p['id'];
      this.loader.showLoadingIcon();
      this.api.Documents.GetDocumentDetails(this.id).subscribe({
        next: (x) => {
          this.selectedDoc = x;
          this.loader.hideLoadingIcon();
        },
        error: (error) => {
          this.snackbar.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Document has been deleted or does not exist.',
          });
          this.loader.hideLoadingIcon();
          this.router.navigate(['document-library']);
        },
      });
      const userBookmarks = JSON.parse(
        sessionStorage.getItem('UserBookmarks') ?? '',
      );
      for (let i = 0; i < userBookmarks.length; i++) {
        if (
          userBookmarks[i].ForeignKey == this.id &&
          userBookmarks[i].BookmarkType == this.bookmarkType
        ) {
          this.isBookmark = !this.isBookmark;
        }
      }
    });
  }

  copyLink() {
    const url = window.location.href;
    navigator.clipboard.writeText(url).then(
      () => {
        this.snackbar.add({
          severity: 'success',
          summary: 'Copied',
          detail: 'Document link copied to clipboard!',
        });
      },
      () => {
        this.snackbar.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to copy link.',
        });
      },
    );
  }

  toggleBookmark(isBookmarked: boolean) {
    if (!isBookmarked) {
      this.url = window.location.href;
      this.bookmarkName = this.selectedDoc?.Title;
      const dialogRef = this.dialog.open(HrtBookmarkComponent, {
        data: { url: this.url, bookmarkName: this.bookmarkName },
      });

      dialogRef.afterClosed().subscribe((result) => {
        this.bookmarkName = result;
        if (result) {
          this.api.Bookmark.AddBookmark(
            this.id,
            this.bookmarkType,
            this.url,
            this.bookmarkName,
          ).subscribe({
            next: (x) => {
              this.isBookmark = !this.isBookmark;
              this.snackbar.add({
                severity: 'success',
                summary: 'Success',
                detail: 'Bookmark added successfully!',
              });
            },
            error: (err) => {
              this.snackbar.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Error adding bookmark: ' + err,
              });
            },
          });
          let existingBookmarks = JSON.parse(
            sessionStorage.getItem('UserBookmarks') || '',
          );
          existingBookmarks.push({
            ForeignKey: this.id,
            BookmarkType: this.bookmarkType,
          });
          sessionStorage.setItem(
            'UserBookmarks',
            JSON.stringify(existingBookmarks),
          );
        }
      });
    } else {
      this.api.Bookmark.DeleteBookmark(this.id, this.bookmarkType).subscribe({
        next: (x) => {
          this.isBookmark = !this.isBookmark;
          this.snackbar.add({
            severity: 'info',
            summary: 'Information',
            detail: 'Bookmark removed successfully!',
          });
        },
      });
      let existingBookmarks = JSON.parse(
        sessionStorage.getItem('UserBookmarks') || '',
      );
      existingBookmarks = existingBookmarks.filter(
        (bookmark: { ForeignKey: number; BookmarkType: string }) =>
          !(
            bookmark.ForeignKey === this.id &&
            bookmark.BookmarkType === this.bookmarkType
          ),
      );
      sessionStorage.setItem(
        'UserBookmarks',
        JSON.stringify(existingBookmarks),
      );
    }
  }

  downloadDocument(doc: Document) {
    this.downloading = true;
    this.snackbar.add({
      severity: 'info',
      summary: 'Information',
      detail: 'Downloading ' + doc.Title,
    });
    this.api.Documents.DownloadDocument(doc, (err: string) => {
      if (err) {
        this.snackbar.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error downloading document: ' + err,
        });
      } else {
        this.snackbar.add({
          severity: 'success',
          summary: 'Download',
          detail: 'Download complete!',
        });
      }
      this.downloading = false;
    });
  }

  goBack() {
    this.router.navigate(['document-library']);
  }
}
